var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBream(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185.9 97.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#2772af;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M37.22,29.8c-2.7,2.1-4.3,3.3-6.3,4-1.3,.4-2.6,.6-3.9,1-7,2.2-11.1,9.5-17.7,12.8-1.4,.7-2.9,1.2-4.3,2s-2.6,2-2.9,3.6c-.3,1.2,0,2.5,.6,3.7,1.8,3.6,5.6,5.7,9.4,7.1,3.3,1.3,6.6,2.3,10,3.1,4.6,1.1,7.9,.8,14.2,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M34.42,32.9c3.7,1.7,6.8,4.6,8.7,8.2s2.6,7.8,1.9,11.8c-.5,3.1-1.8,5.9-3.1,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M145.72,62.1c-5.1,0-4.6,0-8.9,.7-4.5,.7-7.9,2.4-12.6,4.5-7.3,3.2-15.6,8.2-22.8,11.5-16,7.2-33.4,6.9-50,.8-5.4-2-9.8-5.7-14.9-8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M138.32,62.3c3.4-3.7,3.4-14.6,0-20.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 23.32,
    cy: 49.2,
    r: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M26.62,67.9c5.2-1.2,6.6-4.5,7.8-9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M141.12,52.3q8.5,.2,18.9,.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M153.12,40.5q6.4,.2,14.3,.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M154.22,64.1q7.3,.2,16.3,.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M145.72,62.1c10.5,1.2,19.5,7.3,29.4,10.9,2.6,1,5.2,1.7,8.7,2.3,1.7,.3-24.8-19.3-23.8-23,2.7-10.6,25.1-26.5,23.3-26.3-2.8,.3-5.8,1-8.2,2.1-4.9,2.3-9.6,4.9-14.2,7.7-5.2,3.2-11.3,7.8-17.8,7.2-2.1-.2-4.3-1.1-6.3-1.7-9-2.7-16.1-5.9-20.8-8.4-.5-.3-1.1-.6-1.6-.9-8.6-4.6-17.2-9.1-26.8-11.2-9.5-2.1-19.5-2.2-29,.3-8.6,2.3-17.3,4.8-24.2,10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M81.12,19.8L115.02,2s1,6.5-2.4,12.5c-2.5,4.5-8.2,10.2-10.2,11.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 93.62,
    y1: 21.4,
    x2: 100.82,
    y2: 16.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M98.72,80.5s1.9,2.6,8.9,5.2,13.9,4,13.9,4c0,0-6.4-2.9-4.7-7.8,1.7-4.9,7.2-8.6,7.2-8.6,0,0,5.3-3.3,6.5-3.5l1.2-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.62,75.8c1.7,1.1,5.4,3.1,7.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M119.22,69.9c1.7,1.1,3.4,2,5.2,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.72,82.9c0,5.4,3.4,8.1,5.1,9.8,1.6,1.7,4.8,3.2,4.8,3.2-.2-.1-.3-1.5-.4-1.7-.2-1-.2-2-.2-3.1,0-.9,0-1.2,.1-2.9,0-.4-4.7-4.7-4.7-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M48.72,63.5c2.7,6.2,7.9,11,14.5,12.3,4.8,1,8.5,1.1,8.5,1.1,0,0-6.4-6-8.5-7.6l-9-7.2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBream);
export default __webpack_public_path__ + "static/media/Bream.31c4afa5ccbfb8d84d50ca9bd9f0f81b.svg";
export { ForwardRef as ReactComponent };